var NeoUtils = (function () {
  var pub = {};
  pub.addEventHandler = function (element, type, eventHandler) {
    if (element === null || element === undefined) {
      return;
    }
    if (element.addEventListener) {
      element.addEventListener(type, eventHandler, false);
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, eventHandler);
    } else {
      element['on' + type] = eventHandler;
    }
  };

  pub.removeEventHandler = function (element, type, eventHandler) {
    if (element === null || element === undefined) {
      return;
    }
    if (element.removeEventListener) {
      element.removeEventListener(type, eventHandler, false);
    } else if (element.detachEvent) {
      element.detachEvent('on' + type, eventHandler);
    } else {
      element['on' + type] = null;
    }
  };

  var mobile   = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
  var android = (navigator.userAgent.match(/Android/i) !== null);
  var internetexploder   = /MSIE|Trident/i.test(navigator.userAgent);
  var internetexploder10   = false;
  var internetexploder11   = false;
  var moz = /Mozilla/i.test(navigator.userAgent);
  var chrome = false;
  if (window.chrome) {
    chrome = true;
  }
  var ontouchstart = 'ontouchstart' in document.documentElement;

  var touchEnabled = false;

  touchEnabled = ontouchstart;

  if (moz === true && chrome === false) {
    touchEnabled = false;
  }

  if (mobile === true) {
    touchEnabled = true;
  }

  if (internetexploder === true) {
    if (window.navigator.pointerEnabled) {
      touchEnabled = true;
      internetexploder11 = true;
    } else if (window.navigator.msPointerEnabled) {
      // drop ie10 touch users
      touchEnabled = false;
      internetexploder10 = true;
    }
  }


  var DOWNEVENTTYPE = 'mousedown';
  if (touchEnabled === true) {
    if (internetexploder === true) {
      if (window.navigator.pointerEnabled) {
        DOWNEVENTTYPE = 'pointerdown';
      } else if (window.navigator.msPointerEnabled) {
        DOWNEVENTTYPE = 'MSPointerDown';
      }
    } else {
      DOWNEVENTTYPE = 'touchstart';
    }
  }

  var MOVEEVENTTYPE = 'mousemove';
  if (touchEnabled === true) {
    if (internetexploder === true) {
      if (window.navigator.pointerEnabled) {
        MOVEEVENTTYPE =  'pointermove';
      } else if (window.navigator.msPointerEnabled) {
        MOVEEVENTTYPE =  'MSPointerMove';
      }
    } else {
      MOVEEVENTTYPE =  'touchmove';
    }
  }

  var UPEVENTTYPE = 'mouseup';

  if (touchEnabled === true) {
    if (internetexploder === true) {
      if (window.navigator.pointerEnabled) {
        UPEVENTTYPE = 'pointerup';
      } else if (window.navigator.msPointerEnabled) {
        UPEVENTTYPE = 'MSPointerUp';
      }
    } else {
      UPEVENTTYPE = 'touchend';
    }
  }

  pub.getInfoHTML = function () {

    var info = 'mobile: '+mobile+'<br>';
    info += 'android: '+android+'<br>';
    info += 'internetexploder: '+internetexploder+'<br>';
    info += 'internetexploder10: '+internetexploder10+'<br>';
    info += 'internetexploder11: '+internetexploder11+'<br>';

    info += 'moz: '+moz+'<br>';
    info += 'chrome: '+chrome+'<br>';

    info += 'ontouchstart: '+ontouchstart+'<br><br>';
    info += 'touchEnabled: '+touchEnabled+'<br>';


    info += 'DOWNEVENTTYPE: '+DOWNEVENTTYPE+'<br>';
    info += 'MOVEEVENTTYPE: '+MOVEEVENTTYPE+'<br>';
    info += 'UPEVENTTYPE: '+UPEVENTTYPE+'<br>';

    return info;
  };

  pub.addDownHandler = function (element, handler) {
    pub.addEventHandler(element,DOWNEVENTTYPE,handler);
  };

  pub.addMoveHandler = function (element, handler) {
    pub.addEventHandler(element,MOVEEVENTTYPE,handler);
  };

  pub.addUpHandler = function (element, handler) {
    pub.addEventHandler(element,UPEVENTTYPE,handler);
  };

  pub.removeDownMoveUpHandlers = function (element, handler) {
    pub.removeEventHandler(element,DOWNEVENTTYPE,handler);
    pub.removeEventHandler(element,MOVEEVENTTYPE,handler);
    pub.removeEventHandler(element,UPEVENTTYPE,handler);
  };

  var normalBrowser = document.all ? false : true;

  pub.getMouseX = function (event) {
    if (internetexploder === true) {
      return window.event.clientX;
    } else if (touchEnabled === true) {
      return event.touches[0].pageX;
    } else if (normalBrowser === true){
      return event.pageX;
    } else {
      return window.event.clientX;
    }
  };

  pub.getMouseY = function (event) {
    if (internetexploder === true) {
      return window.event.clientY;
    } else if (touchEnabled === true) {
      return event.touches[0].pageY;
    } else if (normalBrowser === true){
      return event.pageY;
    } else {
      return window.event.clientY;
    }
  };

  pub.getTime = function () {
    var d = new Date();
    var t = d.getTime();
    return t;
  };



  /*
  pub.loadRes = function (locale, callback) {
    console.log('loading resources for: ' + locale);
    var bla = 'en';
    if (locale.match(/de/i) !== null) {
      bla = 'de';
    }
    var currentFile = 'scripts/design/res/res_' + bla + '.js';
    LazyLoad.js(currentFile, function () {
      pub.langRes = NeoUtils.langRes;
      callback();
    });
  };
  */

  return pub;
}());